import { Injectable } from '@angular/core';
import { ZopDrawerComponent } from './drawer.component';

@Injectable({ providedIn: 'root' })
export class ZopDrawerService {
  private _componentRegistry: Map<string, ZopDrawerComponent> = new Map<
    string,
    ZopDrawerComponent
  >();

  /**
   * Constructor
   */
  constructor() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register drawer component
   *
   * @param name
   * @param component
   */
  registerComponent(name: string, component: ZopDrawerComponent): void {
    this._componentRegistry.set(name, component);
  }

  /**
   * Deregister drawer component
   *
   * @param name
   */
  deregisterComponent(name: string): void {
    this._componentRegistry.delete(name);
  }

  /**
   * Get drawer component from the registry
   *
   * @param name
   */
  getComponent(name: string): ZopDrawerComponent | undefined {
    return this._componentRegistry.get(name);
  }
}
